<!-- <app-spinner></app-spinner> -->
<div class="container">
  <div class="titulo">
    <p class="sub-titulo">BUSCA TU SOLICITUD</p>
  </div>
  <form action="" autocomplete="off" [formGroup]="formRequest">
    <div class="card">
      <mat-form-field appearance="fill">
        <mat-label>Número de solicitud</mat-label>
        <input
          autocomplete="off"
          matInput
          placeholder="Ingrese su número de solicitud"
          formControlName="requestNum"
        />
        <mat-error
          *ngIf="
            formRequest.controls['requestNum'].invalid &&
            formRequest.controls['requestNum'].touched
          "
        >
          <span
            *ngIf="
              formRequest.controls['requestNum'].errors
                ? formRequest.controls['requestNum'].errors['required']
                : ''
            "
            >Debe completar este campo</span
          >
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Dirección de correo electronico</mat-label>
        <input
          autocomplete="off"
          matInput
          placeholder="Ingrese su dirección de correo electrónico"
          formControlName="mail"
        />
        <mat-error
          *ngIf="
            formRequest.controls['mail'].invalid &&
            formRequest.controls['mail'].touched
          "
        >
          <span
            *ngIf="
              formRequest.controls['mail'].errors
                ? formRequest.controls['mail'].errors['email']
                : ''
            "
            >El formato es incorrecto</span
          >
          <span
            *ngIf="
              formRequest.controls['mail'].errors
                ? formRequest.controls['mail'].errors['required']
                : ''
            "
            >Debe completar este campo</span
          >
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" *ngIf="disableButtonValidate">
        <mat-label>Código de seguridad</mat-label>
        <input
          appNumber
          autocomplete="off"
          matInput
          placeholder="Ingrese su código de seguridad"
          formControlName="securityCode"
        />
        <mat-error
          *ngIf="
            formRequest.controls['securityCode'].invalid &&
            formRequest.controls['securityCode'].touched
          "
        >
          <span
            *ngIf="
              formRequest.controls['securityCode'].errors
                ? formRequest.controls['securityCode'].errors['esecurityCode']
                : ''
            "
            >El formato es incorrecto</span
          >
          <span
            *ngIf="
              formRequest.controls['securityCode'].errors
                ? formRequest.controls['securityCode'].errors['required']
                : ''
            "
            >Debe completar este campo</span
          >
        </mat-error>
        <mat-error
          *ngIf="formRequest.controls['securityCode'].hasError('pattern')"
          >Debe ingresar 6 caracteres</mat-error
        >
      </mat-form-field>
      <div class="button-position">
        <button
          (click)="validateRequest()"
          [disabled]="disableButtonSearch()"
          mat-flat-button
          class="boton-buscar"
          *ngIf="!disableButtonValidate"
        >
          BUSCAR
        </button>
        <button
          mat-flat-button
          class="boton-buscar"
          *ngIf="disableButtonValidate"
          [disabled]="!formRequest.valid"
          (click)="validateSegurityCode(false)"
        >
          VALIDAR
        </button>
      </div>
    </div>
  </form>
</div>
